<script lang="ts" setup>
import InstructureBadge from "~/components/InstructureBadge.vue";
</script>

<template>
    <div class="flex flex-wrap items-center justify-around gap-x-12 gap-y-10">
        <a href="https://usfcr.com" target="_blank">
            <NuxtImg
                src="https://usfcr.com/assets/img/verified-vendor-seal-2024-sm.png"
                alt="USFCR Verified Vendor"
                title="US Federal Contractor Registration System for Award Management Verified Vendor Seal"
                class="h-[100px]"
            />
        </a>
        <a href="https://www.gachamber.com/" target="_blank">
            <NuxtImg
                src="/images/home/credentials/gachamber.png"
                alt="Georgia Chamber"
                title="Georgia Chamber of Commerce"
                class="h-[100px]"
            />
        </a>
        <a href="https://www.bbb.org" target="_blank">
            <NuxtImg
                src="/images/home/credentials/bbb.png"
                alt="BBB"
                title="Better Business Bureau"
                class="h-[100px]"
            />
        </a>

        <a href="https://publishers.org/" target="_blank">
            <NuxtImg
                src="/images/home/credentials/aap.png"
                alt="AAP"
                title="Association of American Publishers"
                class="h-[100px]"
            />
        </a>

        <a href="https://www.wbenc.org" target="_blank">
            <NuxtImg
                src="/images/home/credentials/wbenc.png"
                alt="WBENC"
                title="Women's Business Enterprise national Council"
                class="h-[100px]"
            />
        </a>

        <div>
            <InstructureBadge />
        </div>
    </div>
</template>

<style scoped></style>
